import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { PARENT_PARAMS_TYPE, INIVATE_TYPE, PARENT_TYPE } from 'Pages/partnerProfile'

export type InivateState = {
	new_partner: PARENT_TYPE | null
	inivate_type: INIVATE_TYPE
}

const initialState: InivateState = {
	new_partner: null,
	inivate_type: INIVATE_TYPE.NEW,
}

export namespace InivateNS {
	export type GetPartnerNew = PayloadAction<PARENT_PARAMS_TYPE>
	export type SetPartnerNew = PayloadAction<PARENT_TYPE>
	export type SetInivateType = PayloadAction<INIVATE_TYPE>
}

export const inivateSlice = createSlice({
	name: 'inivate',
	initialState,
	reducers: {
		getPartnerNew: (state, action: InivateNS.GetPartnerNew) => {},
		setPartnerNew: (state, action: InivateNS.SetPartnerNew) => {
			state.new_partner = action.payload
		},
		clearAll: (state) => {
			state.new_partner = null
		},
		setInivateType: (state, action: InivateNS.SetInivateType) => {
			state.inivate_type = action.payload
		},
	},
})
